export const variantOutlined = () => ({
  _focus: {
    borderColor: 'var(--chakra-ui-focus-ring-color)',
    boxShadow: '0 0 0 2px var(--chakra-ui-focus-ring-color)'
  }
});
export const variantFilled = () => ({
  _focus: {
    borderColor: 'var(--chakra-ui-focus-ring-color)',
    boxShadow: '0 0 0 1px var(--chakra-ui-focus-ring-color)'
  }
});
export const variantFlushed = () => ({
  _focus: {
    borderColor: 'var(--chakra-ui-focus-ring-color)',
    boxShadow: '0 1px 0 0 var(--chakra-ui-focus-ring-color)'
  }
});